import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import dayjs from 'dayjs'
import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
import storejs from  'store'
import expirePlugin from  'store/plugins/expire'
import 'font-awesome/css/font-awesome.min.css'
import {authJWT} from './api/api'

Vue.use(ElementUI, { size: 'small' });

Vue.use(VueRouter)
Vue.use(Vuex)
storejs.addPlugin(expirePlugin)
Vue.prototype.$storejs = storejs
Vue.prototype.$dayjs = dayjs

NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let userInfo = sessionStorage.getItem(process.env.VUE_APP_APPKEY+'userInfo');
  let token= storejs.get(process.env.VUE_APP_APPKEY+"token")
  if(userInfo&&token){
    if (to.path == '/login') {
      next({ path: '/main' })
    }else if(to.path == '/'){
      next({ path: '/main' })
    }else{
      next()
    }
  }else if(token){
    authJWT().then(response => {
      let {data} = response
      if(data.status==200){
        sessionStorage.setItem(process.env.VUE_APP_APPKEY+'userInfo', JSON.stringify(data.data.userInfo));
        next()
      }else{
        storejs.remove(process.env.VUE_APP_APPKEY+'token')
        next({ path: '/login' })
      }
    })
  }else{
    if (to.path == '/login') {
      next()
    }else{
      next({ path: '/login' })
    }
  }
})

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
